import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { User, UserService } from '@sabstravtech/obtservices/angular';
import { DifferentInvokdedUserReasons } from '@sabstravtech/obtservices/base';

import { LightningModalTypes } from '../../core/classes/modal-types.enum';

@Component({
  selector: 'app-different-invoked-user',
  templateUrl: './different-invoked-user.component.html',
  styleUrls: ['./different-invoked-user.component.scss'],
  standalone: false
})
export class DifferentInvokdedUserComponent implements OnInit {
  // Inputs provided by caller.
  basketBobo: User = null;
  currentBobo: User = null;
  displayItinerary = false;

  // Other fields
  DifferentInvokdedUserReasons = DifferentInvokdedUserReasons;
  isAgent = false;

  constructor(
    public activeModal: NgbActiveModal,
    private userService: UserService
  ) {}

  ngOnInit(): void {
    this.displayItinerary = this.userService.isBasketReplacementUserFavouriteSet();
    this.isAgent = this.userService.userIsAgent();
  }
}

LightningModalTypes.DifferentInvokdedUserComponent.component = DifferentInvokdedUserComponent;
